var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9307 11.6667L20.0715 7.94819C19.5364 6.87801 19.2689 6.34288 18.8697 5.95194C18.5167 5.60622 18.0913 5.34329 17.6242 5.18218C17.096 5 16.4978 5 15.3012 5H8.93075C7.0639 5 6.13048 5 5.41744 5.36331C4.79024 5.68289 4.2803 6.19282 3.96072 6.82003C3.59741 7.53307 3.59741 8.46649 3.59741 10.3333V11.6667M3.59741 11.6667H28.9307C31.731 11.6667 33.1311 11.6667 34.2007 12.2116C35.1415 12.691 35.9064 13.4559 36.3858 14.3967C36.9307 15.4663 36.9307 16.8664 36.9307 19.6667V27C36.9307 29.8003 36.9307 31.2004 36.3858 32.27C35.9064 33.2108 35.1415 33.9757 34.2007 34.455C33.1311 35 31.731 35 28.9307 35H11.5974C8.79715 35 7.39702 35 6.32746 34.455C5.38665 33.9757 4.62175 33.2108 4.14238 32.27C3.59741 31.2004 3.59741 29.8003 3.59741 27V11.6667ZM15.2641 23.3333L18.5974 26.6667L26.0974 19.1667",
    stroke: "#278DEC",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderTick);
export default __webpack_public_path__ + "static/media/folderTick.cd595f8e44382853de07c33624dd3573.svg";
export { ForwardRef as ReactComponent };